import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MapController } from '../map-controller';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'map-footer',
    providers: [],
    templateUrl: './map-footer.component.html',
    styleUrls: ['./map-footer.component.css']
})
export class MapFooterComponent implements OnInit, OnChanges {

    @Input("mapctrl") mapCtrl: MapController = null;
    @Input("htmlContent") htmlContent: string = '<div> test dinamic component</div><div>ddd</div>';
    
    public safeHtml: SafeHtml = '';
    
    public constructor(
        @Inject(DomSanitizer) private sanitizer: DomSanitizer
        ){
        //
    }
    
    public ngOnInit(): void {
        this.updateHtmlContent();
    }
    
    public ngOnChanges(changes: SimpleChanges) {
        if (changes['htmlContent']) {
            this.updateHtmlContent();
        }
    }
    
    private updateHtmlContent(): void {
        if (this.htmlContent) {
            this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.htmlContent);
        } else {
            this.safeHtml = '';
        }
    }

}